/**
 * @param {{
 *   width?: string | number,
 *   height?: string | number,
 *   borderRadius?: string | number,
 *   className?: string,
 * }} props
 */
export default function Skeleton({ width = "100%", height = 16, borderRadius = 6, className = "" }) {
  const w = typeof width === "number" ? `${width}px` : width;
  const h = typeof height === "number" ? `${height}px` : height;
  const r = typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius;
  return (
    <div
      className={`idwiz-skeleton-block ${className}`.trim()}
      style={{
        width: w,
        height: h,
        borderRadius: r,
      }}
      aria-hidden
    />
  );
}
